import { ICustomer } from "api/types";
import { FormContainer } from "components/common/Form/FormContainer";
import ConnectedKeyboard from "components/common/Keyboard/ConnectedKeyboard";
import useKeyboardForm from "components/common/Keyboard/Keyboard.hooks";
import React, { FunctionComponent, useEffect } from "react";
import OnboardingContainer from "screens/Onboarding/Onboarding.container";
import CustomerPersonalInfoForm from "screens/Onboarding/SignUp/CustomerPersonalInfo/CustomerPersonalInfoForm";
interface IProps {
  currentCustomer?: ICustomer;
  onSubmit: any;
  submitButtonText?: string;
  error?: string;
  completed?: boolean;
  showCompleteLater?: boolean;
  loading?: boolean;
  removeFirstLastname?: boolean;
}

const CustomerPersonalInfoEditor: FunctionComponent<IProps> = ({
  onSubmit,
  currentCustomer,
  error,
  submitButtonText,
  showCompleteLater,
  loading,
  completed,
  removeFirstLastname
}) => {
  const {
    firstName,
    lastName,
    email,
    birthday,
    zipcode,
    setBirthday,
    setEmail,
    setFirstName,
    setLastName,
    setZipcode
  } = OnboardingContainer.useContainer();

  const initialInputFields = currentCustomer
    ? currentCustomer
    : {
        firstName,
        lastName,
        email,
        zipcode,
        birthday
      };

  const { inputFields, onChange, onFocusIn } = useKeyboardForm(
    initialInputFields
  );

  useEffect(() => {
    setBirthday(inputFields.birthday);
    setEmail(inputFields.email);
    setFirstName(inputFields.firstName);
    setLastName(inputFields.lastName);
    setZipcode(inputFields.zipcode);
  }, [inputFields]);

  return (
    <>
      <FormContainer>
        <CustomerPersonalInfoForm
          onChange={onChange}
          inputFields={inputFields}
          onFocusIn={onFocusIn}
          onSubmit={onSubmit}
          showCompleteLater={showCompleteLater}
          error={error}
          loading={loading}
          completed={completed}
          submitButtonText={submitButtonText}
          removeFirstLastname={removeFirstLastname}
        />
      </FormContainer>
      <ConnectedKeyboard onChange={onChange} />
    </>
  );
};

export default CustomerPersonalInfoEditor;



// WEBPACK FOOTER //
// ./src/screens/Onboarding/SignUp/CustomerPersonalInfo/CustomerPersonalInfoEditor.tsx